module.exports = __webpack_public_path__ + "static/commerce2x-support-a121b1f16dc46ab0ea7697c9cc3c0fd7.png";